import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { NoticeboardButton } from "../shared";

interface DidYouKnowCardProps {
  onSetupAdCenter: () => void;
}

const DidYouKnowCard: React.FC<DidYouKnowCardProps> = ({ onSetupAdCenter }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 3,
        p: { xs: 3, sm: 4 },
        border: "1px solid",
        borderColor: "divider",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      {/* Image on top */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mb: 3,
        }}
      >
        <Box
          component="img"
          src="/home/didyouknow.webp"
          alt="Did you know illustration"
          loading="lazy"
          decoding="async"
          sx={{
            maxWidth: { xs: 300, sm: 400, md: 500 },
            width: "100%",
            height: "auto",
            objectFit: "contain",
          }}
        />
      </Box>

      {/* Content below image */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          width: "100%",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 500,
              color: "text.primary",
            }}
          >
            Make Money with Noticeboard
          </Typography>
        </Box>
        <Typography
          variant="body1"
          sx={{
            color: "text.secondary",
          }}
        >
          Turn your community into a revenue stream. Activate your Circles Ad Center in minutes.
        </Typography>
        <NoticeboardButton
          variant="secondary"
          onClick={onSetupAdCenter}
          sx={{ alignSelf: "center", mt: 1 }}
        >
          Set Up Your Ad Center
        </NoticeboardButton>
      </Box>
    </Paper>
  );
};

export default DidYouKnowCard;
